export default {
  "Categories": "分类",
  "Filters": "筛选",
  "Sort_by": "排序方式",
  "Category_found_Products": "找到的产品",
  "About us": "关于我们",
  "Who we are": "我们是谁",
  "Quality in the details": "注重细节的品质",
  "Customer Reviews": "客户评价",
  "Departments": "法律声明",
  "Women fashion": "女装",
  "Men fashion": "男装",
  "Kidswear": "童装",
  "Home": "首页",
  "Help": "帮助",
  "Customer service": "客户服务",
  "Size guide": "尺码指南",
  "Contact_us": "联系我们",
  "SERVICE": "服务",
  "Purchase terms": "购买条款",
  "Guarantee": "保证",
  "Description": "描述",
  "Read_reviews": "阅读评论",
  "Additional_info": "附加信息",
  "CartSliderTextBtn": "保存到稍后购买",
  "Add to compare": "添加到比较",
  "Match": "搭配",
  "Share your look": "分享你的造型",
  "Product_description": "Karissa V-Neck Tee采用半合身设计，适合各种身材。它紧贴曲线，遮盖常见的“问题”区域，让你自信地去健身房。还有惊艳的女士鸡尾酒礼服和派对礼服。",
  "Brand": "品牌",
  "Instruction1": "保养方式",
  "Instruction2": "只需要保养说明？",
  "Instruction3": "是的，我们知道",
  "Items": "商品",
  "View": "查看",
  "Show on page": "显示在页面上",
  "Done": "完成",
  "Clear all": "清空所有",
  "Empty": "看起来您还没有添加任何商品到购物袋中。开始购物以填满它。",
  "TopBar_help": "帮助与常见问题解答",
  "Download": "下载",
  "Find out more": "了解更多",
  "Login": "登录",
  "Login_forgotten_password": "忘记密码？",
  "Login_no_account": "还没有账户？",
  "Login_Register": "立即注册",
  "Go_to_checkout": "去结算",
  "Go_back_shopping": "返回购物",
  "Personal details": "个人资料",
  "Edit": "编辑",
  "Shipping_details": "收货地址",
  "Billing_address": "账单地址",
  "Same as shipping address": "与送货地址相同",
  "Payment method": "付款方式",
  "Apply": "应用",
  "MyAccount_MyProfile_Update": "更新密码",
  "Update personal data": "更新个人资料",
  "Item": "商品",
  "Go_back": "返回",
  "Continue to shipping": "继续运输",
  "payment_agree_1": "我同意",
  "payment_agree_2": "条款和条件",
  "Pay_Order": "支付订单",
  "Log into your account": "登录您的账户",
  "or fill the details below": "或填写以下细节",
  "Enjoy your free account": "享受您的免费账户特权！",
  "Continue_to_payment": "继续支付",
  "Order_No": "订单编号",
  "Successful placed order": "您已成功下单。您可以使用我们的交付状态功能检查订单状态。您将收到一封包含订单详细信息和跟踪链接的订单确认电子邮件。",
  "Info after order": "您可以使用之前定义的电子邮件和密码登录您的账户。在您的账户中，您可以编辑个人资料、查看交易历史记录、编辑订阅通讯等。",
  "Allow order notifications": "允许订单通知",
  "Feedback": "您的反馈对我们很重要。请告诉我们我们可以改进什么。",
  "Send my feedback": "发送我的反馈",
  "Go back to shop": "返回商店",
  "Read_all_reviews": "阅读所有评论",
  "Color": "颜色",
  "Contact details updated": "保持您的地址和联系方式更新。",
  "Manage billing addresses": "管理所有希望的账单地址（工作场所、家庭地址...）这样您就不必在每个订单中手动输入账单地址。",
  "Change": "更改",
  "Delete": "删除",
  "MyAccount_ShippingDetails_Add": "添加新地址",
  "MyAccount_ShippingDetails_Update": "更新地址",
  "MyAccoubnt_Set_newsletter": "设置您的新闻通讯，我们每周会向您发送您选择的部分的新产品和趋势信息。",
  "Sections that interest you": "您感兴趣的部分",
  "MyAccount_MyProfile_Save": "保存更改",
  "Read and understand": "我已阅读并理解",
  "Privacy": "隐私",
  "Cookies Policy": "Cookie政策",
  "Commercial information": "并同意通过电子邮件接收Brand name的个性化商业信息",
  "Feel free to edit": "随时编辑您的任何详细信息，以便您的帐户始终保持最新状态",
  "Use your personal data": "在Brand name，我们非常重视隐私问题，并致力于保护我们用户的个人数据。了解有关我们如何关心和使用您的个人数据的更多信息，请参阅",
  "Privacy_Policy": "隐私政策",
  "Change password your account": "如果您想更改访问帐户的密码，请输入以下信息",
  "Your current email address is": "您当前的电子邮件地址为",
  "Product": "产品",
  "Details_and_status_orders": "在在线商店中检查订单的详细信息和状态。您还可以取消订单或请求退货。",
  "You currently have no orders": "您目前没有订单",
  "Start_shopping": "开始购物",
  "Download all": "全部下载",
  "Order_View_details": "查看详情",
  "Manage shipping addresses": "管理您想要的所有送货地址（工作场所，家庭地址...）这样您就不必在每个订单中手动输入送货地址。",
  "Quantity": "数量",
  "Price": "价格",
  "Back to homepage": "返回首页",
  "Select shipping method": "选择配送方式",
  "Review my order": "查看我的订单",
  "Select payment method": "选择支付方式",
  "payment_make_order": "下单",
  "or": "或者",
  "login_logbtn": "登录账户",
  "Login_Create": "创建账户",
  "Wishlist_Empty": "没有心愿单",
  "wishlist_empty_title": "您的心愿单是空的",
  "wishlist_empty_desc": "看起来您还没有添加任何商品到心愿单中",
  "Cancel": "取消",
  "See all results": "查看所有结果",
  "search_results_not": "我们没有找到与给定短语相关的结果",
  "search_results_inputnull": "您还没有搜索任何商品。",
  "search_results_inputnull2": "现在开始吧，我们会帮助您。",
  "Search_results_title": "搜索结果",
  "Product suggestions": "产品建议",
  "Search_items": "搜索",
  "Enter_promo_code": "输入优惠码",
  "Shipping_method": "运输方式",
  "Continue_billing": "继续结算",
  "Payment methods": "付款方式",
  "Shipping_title": "收货地址",
  "Subtotal": "小计",
  "Shipping": "配送",
  "Total_price": "总价",
  "Shipping_Tax": "运费税",
  "Payment": "支付",
  "Order summary": "订单摘要",
  "Products": "产品",
  "Total": "总计",
  "Reset_Password": "重置密码",
  "Save_Password": "保存密码",
  "Back_to_home": "返回首页",
  "Login_Forgot_Password": "如果您无法记住密码，可以重置密码。",
  "Thank_You_Inbox": "如果消息未到达收件箱，请尝试使用您可能用于注册的另一个电子邮件地址。",
  "Sign in": "登录",
  "Register": "注册",
  "Password_Changed": "密码已成功更改。您现在可以返回主页并登录。",
  "Password": "密码",
  "Repeat_Password": "重复密码",
  "Forgot Password Modal Email": "您用于登录的电子邮件：",
  "forgotPasswordConfirmation": "谢谢！如果使用 {0} 邮箱注册了帐户，则会在收件箱中找到包含密码重置链接的消息。",
  "subscribeToNewsletterModalContent": "订阅通讯后，您将通过电子邮件收到来自 VSF 的特别优惠和信息。我们不会在任何时候出售或分发您的电子邮件给任何第三方。请参阅我们的 {0}。",
  "Subscribe": "订阅",
  "Subscribe_to_newsletter": "订阅通讯",
  "Subscribe_to_message": "了解即将推出的销售和活动。获得礼品和特别优惠！",
  "Subscribe_to_success": "您已订阅",
  "Email_address": "电子邮件地址",
  "confirm_subscription": "我确认订阅",
  "unsubscribe": "您可以随时取消订阅",
  "show_more": "显示更多",
  "hide": "隐藏",
  "Category_Item_Grid": "切换网格视图",
  "Category_Item_List": "切换列表视图",
  "See_all": "全部",
  "Category_sorting_Item": "选择排序方式",
  "more": "更多",
  "address CN": "地址在中国，当前货币必须为人民币",
  "prompt": "提示",
  "match_goods": "热卖商品",
  "choose_language": "选择语言",
  "choose_currency": "选择货币",
  "cart_title": "我的购物车",
  "total_items": "总件数",
  "cart_price": "小计",
  "cart_clear": "清空购物车",
  "cart_empty_title": "您的购物车为空",
  "cart_empty_desc": "看起来您还没有添加任何商品到购物袋中。开始购物以填满它。",
  "switch_CNY": "切换人民币",
  "add_shipping": "添加新的送货地址",
  "shopping_go": "管理送货地址",
  "order_review": "订单评价",
  "Billing": "账单",
  "payment_post_fee": "邮费",
  "payment_post_tax": "邮费税",
  "payment_order_total": "订单总额",
  "payment_order_payment": "订单支付",
  "payment_order_discount": "订单折扣",
  "MyAccount": "我的账户",
  "MyAccount_Personal": "个人资料",
  "MyAccount_Profile": "资料",
  "MyAccount_Newsletter": "订阅",
  "MyAccount_Wishlist": "愿望清单",
  "MyAccount_Order": "订单详情",
  "MyAccount_History": "订单记录",
  "MyAccount_Log_out": "退出登录",
  "Login_input_email": "email",
  "Login_input_password": "密码",
  "Login_input_Remember": "记住我",
  "Login_input_first": "名字",
  "Login_input_last": "姓氏",
  "Login_create_account": "同意使用条款和隐私政策",
  "MyAccount_MyProfile_Tab1": "个人资料",
  "MyAccount_MyProfile_Tab2": "更改密码",
  "MyAccount_MyProfile_label_First": "名字",
  "MyAccount_MyProfile_label_Last": "姓氏",
  "MyAccount_MyProfile_label_email": "email",
  "MyAccount_MyProfile_label2_pass1": "当前密码",
  "MyAccount_MyProfile_label2_pass2": "新密码",
  "MyAccount_MyProfile_label2_pass3": "重复密码",
  "MyAccount_MyProfile_title1": "随时编辑下面的任何详细信息，以便您的帐户始终保持最新状态",
  "MyAccount_ShippingDetails_message_title": "管理您想要的所有送货地址（工作场所、家庭地址等），这样您就不必在每个订单中手动输入送货地址。",
  "MyAccount_ShippingDetails_message_title2": "保持您的地址和联系方式更新。",
  "MyAccount_ShippingDetails_title": "送货详情",
  "MyAccount_ShippingDetails_changeTitle": "更改地址",
  "Country": "国家/地区",
  "MyAccount_MyShippingDetails_First": "名字",
  "MyAccount_MyShippingDetails_Last": "姓氏",
  "MyAccount_MyShippingDetails_Street": "街道",
  "MyAccount_MyShippingDetails_HouseNumber": "门牌号码",
  "MyAccount_MyShippingDetails_City": "城市",
  "MyAccount_MyShippingDetails_State": "州/省",
  "MyAccount_MyShippingDetails_Zip": "邮政编码",
  "MyAccount_MyShippingDetails_Phone": "电话号码",
  "Discount": "折扣",
  "TaxFee": "税费",
  "Amount": "金额",
  "Wishlist": "心愿单",
  "Account": "账户",
  "Basket": "购物篮",
  "ID_Name": "身份证姓名",
  "ID_Name_Error": "请输入您的身份证姓名",
  "ID_Number": "身份证号码",
  "ID_Number_Error": "请输入您的身份证号码",
  "ID_Type": "身份证类型",
  "ID_Type_Error": "请选择您的身份证类型",
  "ORDER_WAIT_PAYMENT": "待支付",
  "ORDER_PAID": "已支付",
  "ORDER_WAIT_SHIP": "待发货",
  "ORDER_WAIT_RECEIPT": "待收货",
  "ORDER_WAIT_RATE": "待评价",
  "ORDER_AFTER_SALE": "售后中",
  "ORDER_REFUNDING": "退款中",
  "ORDER_REFUNDED": "已退款",
  "ORDER_CLOSED": "已关闭",
  "Order_Status": "订单状态",
  "Order_Detail": "订单详情",
  "Order_After_sales": "订单售后",
  "MyAccount_Order_History_Tabs1": "我的订单",
  "MyAccount_Order_History_Tabs2": "待支付",
  "MyAccount_Order_History_Tabs3": "退货",
  "Order_to_be_paid_message": "待支付",
  "Order_after_sales_message": "详情和售后订单",
  "order_after_sales_list_null": "您目前没有售后订单",
  "MyAccount_MyProfile_yinsi_message": "在Brand name，我们非常重视隐私问题，并致力于保护用户的个人数据。了解更多关于我们如何关心和使用您的个人数据的信息，请参阅",
  "MyAccount_MyProfile_yinsi_link": "隐私政策",
  "MyAccount_MyProfile_title2": "如果您想更改访问您的帐户的密码，请输入以下信息：",
  "MyAccount_MyProfile_title3": "您当前的电子邮件地址为",
  "MyAccount_MyProfile_reqeatPassErrMsg": "新密码不一致",
  "contactus_message_placeholder": "请填写您的评论或问题",
  "concactus_label": "意见或问题",
  "concactus_label2": "商店链接",
  "concactus_img": "上传图片",
  "concattus_button": "提交",
  "payment_insurance_fee": "保险费",
  "payment_insurance_tax": "保险税",
  "Order_Date": "订单日期",
  "after_sales_Id": "售后ID",
  "after_sales_status": "售后状态",
  "after_sales_Reason": "售后原因",
  "after_sales_refund": "退款金额",
  "after_sales_refund_order": "订单退款",
  "go_pay_order": "去支付",
  "After_sales": "售后",
  "After_sales_apply": "申请售后",
  "After_sales_form": "填写售后表单",
  "After_sales_save": "保存售后信息",
  "Save": "保存",
  "Shipping_valid_Phone": "请输入有效的电话号码",
  "Shipping_valid_required": "此项为必填项",
  "Shipping_valid_length_min": "该字段至少应有{min}个字符",
  "go_order_history": "查看订单历史记录",
  "colseCookie": "我知道了",
  "BootomCookieLink": "了解更多",
  "BootomCookieContext": "这个网站使用 cookies 来帮助网站正常运行并帮助我们了解如何与它交互。我们使用这些 cookies 来为您提供更好的个性化的用户体验。如果您继续使用本网站，我们将认为您同意使用cookies。",
  "BootomCookieTitle": "Cookie许可",
  "concactus_label3": "标题",
  "concactus_label4": "联系邮件",
  "concactus_label5": "称呼",
  "Review_Content": "评价内容",
  "Order_Grade": "订单评分",
  "Create_Time_Asc": "创建时间升序",
  "Create_Time_Desc": "创建时间降序",
  "All": "全部",
  "Go_To_Order_review": "去评价",
  "MyAccount_Order_History_All": "全部订单",
  "save_order_review": "提交评价",
  "Review": "评价",
  "add_To_Cart": "加入购物车",
  "add_To_Wishlist": "加入心愿单",
  "cartPreviewSafety": "安全配送",
  "cartPreviewSafety_messageinfo": "安全、快速的配送到您的地址",
  "cartPreviewShipping": "便捷运输",
  "cartpreviewShipping_messageinfo": "您将收到发货确认和到货日期",
  "Page_not_found": "页面未找到",
  "An_error_occured": "发生错误",
  "Page_not_found_message1": "很抱歉找不到该页面",
  "Page_not_found_message2": "请返回或重新尝试",
  "Return_home": "返回首页",
  "Back": "返回",
  "Thank_You_Order": "感谢您的订单！",
  "Thank_You_Order_sub": "稍后我们将开始处理您的订单，您将收到一封包含关于订单处理的电子邮件。",
  "Your_Purchase_Order": "您的订单",
  "Your_Account": "您的账户",
  "What_We_Improve": "我们如何改进？",
  "All_After_sales_orders": "全部售后订单",
  "order_count": "订单数",
  "Promo_code": "优惠码",
  "email_geshi_error": "请输入有效的电子邮件地址",
  "cancel_Subscribe": "取消订阅",
  "you_have_subscribed": "您已订阅",
  "email": "电子邮箱",
  "your_email": "您的电子邮箱",
  "zhuanfa_toBePay": "转给朋友代你支付",
  "pleasePayType": "请选择支付方式",
  "linkCopied": "链接已复制，快去粘贴分享给朋友吧",
  'hasInsurance': '是否购买保险',
  'save_and_pay': '保存并支付',
  'article_category': '分类',
  "wechat_code_login": "微信扫码登录",
  "wechat_code_login_message": "请使用微信扫描二维码登录",
  "Please_Use_WeChat_login": "请使用微信登录",
  "Api_Update_success": "更新成功",
  "Links": "链接",
  "Login_input_mobile": "手机号",
  "Login_tab_email": "邮箱",
  "Login_tab_mobile": "手机",
  "mobile_geshi_error": "请输入有效的手机号",
  "mobile_code": "验证码",
  "code.time": "{time}秒后重试",
  "Login_input_code": "验证码",
  "Login_input_mobile_required": "请输入手机号",
  "Login_input_email_required": "请输入邮箱",
  "cat_items_null": "该分类下暂无商品",
  "cat_items_null_des": "您可以浏览其他分类的商品",
  "article_null": "暂无文章",
  "article_null_des": "您可以浏览其他分类的文章",
  "register_email": "邮箱",
  "register_mobile": "手机",
  "Login_with_google": "google登录",
  "Login_with_facebook": "facebook登录",
  "Login_with_wechat": "微信登录",
  "Login_with_microsoft": "微软登录",
  "Login_with_twitter": "twitter登录",
  "order_shopping_firstname": "姓名",
  "inPayOrderAll": "待支付列表",
  "payPrice": "支付金额",
  "ItemPrice": "商品金额",
  "OrderSku": '商品规格',
  "Order_logisticsName": '物流公司',
  "Order_logisticsNo": '物流单号',
  "shipping_add_success": "收货地址创建成功",
  "pay_code_shixiao": "支付二维码已失效",
  "pay_code_refresh": "刷新支付码",
  "concactus_title": "联系我们",
  'Services_Name': '服务名称',
  'Services_Description': '服务描述',
  'Services_Price': '服务费用',
  'WebAutoLang': '您当前的浏览器推荐语言是：{lang}，是否切换到该语言？',
  'SwichLang': '切换语言',
  "goodinfo_null": "暂无商品",
  "goodinfo_null_des": "您可以浏览其他分类的商品",
  "shipping_refresh": '刷新列表',
  "billing_and_shipping": "账单和送货地址一致",
  'select_gift': '选择礼物',
  'select_coupon': '选择优惠券',
  'guest_Login': '游客登录',
  'currentUseCode': '已使用优惠码',
  'notYetUseCode': '未使用优惠码',
  'CouponCode': '优惠码',
  "bind_google": "绑定google",
  "bind_facebook": "绑定facebook",
  "bind_wechat": "绑定微信",
  "bind_microsoft": "绑定微软",
  "bind_twitter": "绑定twitter",
  'bind_wechat_code': '微信二维码',
  'ORDER_PART_PAID': '部分支付',
  'discount_post_fee': '邮费折扣',
  'discount_kou': '{discount}折',
  'post_state_country': '配送费： {country} {state} {postFee} ',
  'claimCoupone': '领取',
  'claimCouponeSuccess': '领取 {name} 成功',
  'Social': '社交',
  'Offline_payment': '线下支付',
  'shopName': '店铺名称',
  'onlineContact': '在线联系',
  'shippingAddress': '详细地址',
  'closeOrder': '取消订单',
  'closeOrderContext': '您确定要取消订单吗？',
  'confirm': '确认',
  'cancel': '取消',
  'close.order.success': '订单取消成功',
  'payment_order_note': '订单备注',
  'MyAccount_Message': '消息',
  'Message': '消息',
  'Message_Empty': '暂无消息',
  'Message_Empty_Title': '您的消息是空的',
  'Message_Read': '已读',
  'go_to_see_prepid': '点这里去查看未支付订单',
  'operate': '操作',
  'removeCartItem': '移除商品',
  'removeCartItemContext': '您确定要移除{title}吗？',
  'shippingItemQty': '配送数量',
  'shippingInfo': '配送信息',
  'Distributor_Details': '分销商',
  'Distributor_Details_Empty': '暂无分销商',
  'Distributor_apply': '申请成为分销商',
  'MyAccount_Distributor': '分销商',
  'MyAccoubnt_Set_Distributor': '申请成为分销商',
  'Distributor_success': '已经成功为分销商',
  'Distributor_copy_url': '复制分销链接',
  'Distributor_copy_success': '复制成功',
  'DistributorAmount': '佣金',
  'Order_Time': '下单时间',
  'Order_User': '下单人',
  'distributor.status.1': '未审核',
  'distributor.status.2': '待结算',
  'distributor.status.3': '已结算',
  'distributor.status.4': '已作废',
  'DistributorSataus': '状态',
  'Distributor_shenheshibai': '分销商审核未通过',
  'Distributor_shenhezhong': '分销商审核中',
  'Distributor_Order_Empty': '暂无分销订单',
  'DeliveryCountry': '配送区域',
  'All_Country': '全部',
  'EG': '埃及',
  'NG': '尼日利亚',
  'ZA': '南非',
  'AC': '阿森松岛',
  'AO': '安哥拉',
  'BF': '布基纳法索',
  'BI': '布隆迪',
  'BJ': '贝宁',
  'BW': '博茨瓦纳',
  'CD': '刚果民主共和国',
  'CF': '中非共和国',
  'CG': '刚果',
  'CI': '科特迪瓦',
  'CM': '喀麦隆',
  'CV': '佛得角',
  'DJ': '吉布提',
  'DZ': '阿尔及利亚',
  'EH': '西撒哈拉',
  'ER': '厄立特里亚',
  'ET': '埃塞俄比亚',
  'GA': '加蓬',
  'GH': '加纳',
  'GM': '冈比亚',
  'GN': '几内亚',
  'GQ': '赤道几内亚',
  'GW': '几内亚比绍',
  'KE': '肯尼亚',
  'KM': '科摩罗',
  'LR': '利比里亚',
  'LS': '莱索托',
  'LY': '利比亚',
  'MA': '摩洛哥',
  'MG': '马达加斯加',
  'ML': '马里',
  'MR': '毛里塔尼亚',
  'MU': '毛里求斯',
  'MW': '马拉维',
  'MZ': '莫桑比克',
  'NA': '纳米比亚',
  'NE': '尼日尔',
  'RE': '留尼旺岛',
  'RW': '卢旺达',
  'SC': '塞舌尔',
  'SD': '苏丹',
  'SH': '圣赫勒拿',
  'SL': '塞拉利昂',
  'SN': '塞内加尔',
  'SO': '索马里',
  'ST': '圣多美和普林西比',
  'SZ': '斯威士兰',
  'TA': '特里斯坦-达库尼亚',
  'TD': '乍得',
  'TG': '多哥',
  'TN': '突尼斯',
  'TZ': '坦桑尼亚',
  'UG': '乌干达',
  'YT': '马约特岛',
  'ZM': '赞比亚',
  'ZW': '津巴布韦',
  'AQ': '南极洲',
  'BV': '布韦岛',
  'FK': '福克兰群岛',
  'GS': '南乔治亚和南桑威奇群岛',
  'TF': '法属南部领地',
  'CN': '中国',
  'TH': '泰国',
  'MY': '马来西亚',
  'TW': '中国台湾',
  'VN': '越南',
  'SG': '新加坡',
  'AE': '阿拉伯联合酋长国',
  'HK': '中国香港特别行政区',
  'ID': '印度尼西亚',
  'IN': '印度',
  'JP': '日本',
  'KR': '韩国',
  'PH': '菲律宾',
  'AF': '阿富汗',
  'AM': '亚美尼亚',
  'AZ': '阿塞拜疆',
  'BD': '孟加拉',
  'BH': '巴林',
  'BN': '文莱',
  'BT': '不丹',
  'CC': '科科斯群岛',
  'GE': '乔治亚',
  'IL': '以色列',
  'IO': '英属印度洋领地',
  'IQ': '伊拉克',
  'IR': '伊朗',
  'JO': '约旦',
  'KG': '吉尔吉斯斯坦',
  'KH': '柬埔寨',
  'KP': '朝鲜',
  'KW': '科威特',
  'KZ': '哈萨克斯坦',
  'LA': '老挝',
  'LB': '黎巴嫩',
  'LK': '斯里兰卡',
  'MM': '缅甸',
  'MN': '蒙古',
  'MO': '中国澳门特别行政区',
  'MV': '马尔代夫',
  'NP': '尼泊尔',
  'OM': '阿曼',
  'PK': '巴基斯坦',
  'PS': '巴勒斯坦',
  'QA': '卡塔尔',
  'SA': '沙特阿拉伯',
  'SY': '叙利亚',
  'TJ': '塔吉克斯坦',
  'TM': '土库曼斯坦',
  'TR': '土耳其',
  'UZ': '乌兹别克斯坦',
  'YE': '也门',
  'ES': '西班牙',
  'IE': '爱尔兰',
  'IT': '意大利',
  'PT': '葡萄牙',
  'RO': '罗马尼亚',
  'RU': '俄罗斯',
  'AD': '安道尔',
  'AL': '阿尔巴尼亚',
  'AT': '奥地利',
  'AX': '奥兰群岛',
  'BA': '波斯尼亚和黑塞哥维那',
  'BE': '比利时',
  'BG': '保加利亚',
  'BY': '白俄罗斯',
  'CH': '瑞士',
  'CY': '塞浦路斯',
  'CZ': '捷克共和国',
  'DE': '德国',
  'DK': '丹麦',
  'EE': '爱沙尼亚',
  'FI': '芬兰',
  'FO': '法罗群岛',
  'FR': '法国',
  'GB': '英国',
  'GG': '格恩西岛',
  'GI': '直布罗陀',
  'GR': '希腊',
  'HR': '克罗地亚',
  'HU': '匈牙利',
  'IM': '曼岛',
  'IS': '冰岛',
  'JE': '泽西岛',
  'LI': '列支敦士登',
  'LT': '立陶宛',
  'LU': '卢森堡',
  'LV': '拉脱维亚',
  'MC': '摩纳哥',
  'MD': '摩尔多瓦',
  'ME': '黑山',
  'MK': '马其顿',
  'MT': '马耳他',
  'NL': '荷兰',
  'NO': '挪威',
  'PL': '波兰',
  'RS': '塞尔维亚',
  'SE': '瑞典',
  'SI': '斯洛文尼亚',
  'SJ': '斯瓦尔巴和扬马廷',
  'SK': '斯洛伐克',
  'SM': '圣马力诺',
  'UA': '乌克兰',
  'VA': '梵蒂冈',
  'US': '美国',
  'CA': '加拿大',
  'GT': '危地马拉',
  'MX': '墨西哥',
  'PA': '巴拿马',
  'AG': '安提瓜岛和巴布达',
  'AI': '安圭拉',
  'AN': '荷属安地列斯',
  'AW': '阿鲁巴',
  'BB': '巴巴多斯岛',
  'BM': '百慕大',
  'BS': '巴哈马',
  'BZ': '伯利兹',
  'CR': '哥斯达黎加',
  'CU': '古巴',
  'DM': '多米尼加',
  'DO': '多米尼加共和国',
  'GD': '格林纳达',
  'GL': '格陵兰',
  'GP': '瓜德罗普',
  'HN': '洪都拉斯',
  'HT': '海地',
  'JM': '牙买加',
  'KN': '圣基茨和尼维斯',
  'KY': '开曼群岛',
  'LC': '圣卢西亚',
  'MQ': '马提尼克',
  'MS': '蒙特塞拉特',
  'NI': '尼加拉瓜',
  'PM': '圣皮埃尔和米克隆群岛',
  'PR': '波多黎各',
  'SV': '萨尔瓦多',
  'TC': '特克斯和凯科斯群岛',
  'TT': '特立尼达和多巴哥',
  'VC': '圣文森特和格林纳丁斯',
  'VG': '维尔京群岛，英属',
  'VI': '维尔京群岛，美属',
  'AU': '澳大利亚',
  'NZ': '新西兰',
  'AS': '美属萨摩亚',
  'CK': '库克群岛',
  'CX': '圣诞岛',
  'FJ': '斐济',
  'FM': '密克罗尼西亚',
  'GU': '关岛',
  'HM': '赫德和麦克唐纳群岛',
  'KI': '基里巴斯',
  'MF': '圣马丁',
  'MH': '马绍尔群岛',
  'MP': '北马里亚纳群岛',
  'NC': '新喀里多尼亚',
  'NF': '诺福克',
  'NR': '瑙鲁',
  'NU': '纽埃',
  'PF': '法属波利尼西亚',
  'PG': '巴布亚新几内亚',
  'PN': '皮特凯恩',
  'PW': '帕劳群岛',
  'SB': '所罗门群岛',
  'TK': '托克劳',
  'TL': '东帝汶',
  'TO': '汤加',
  'TV': '图瓦卢',
  'UM': '美属外岛',
  'VU': '瓦努阿图',
  'WF': '瓦利斯和福图纳',
  'WS': '萨摩亚',
  'AR': '阿根廷',
  'BR': '巴西',
  'CL': '智利',
  'CO': '哥伦比亚',
  'PE': '秘鲁',
  'BO': '玻利维亚',
  'EC': '厄瓜多尔',
  'GF': '法属圭亚那',
  'GY': '圭亚那',
  'PY': '巴拉圭',
  'SR': '苏里南',
  'UY': '乌拉圭',
  'VE': '委内瑞拉',
  'zhichiDeliveryCountry': '配送到',
  'ShippingFee': '配送费',
  'product.pifa.label': '买 {startnum} - {endnum}件',
  'product.pifa.type.1': '折扣',
  'product.pifa.type.2': '单价',
  'product.num.danwei': '个',
  'product.wholesale': '批发价',
  'reviewOutOf': '{rating} 星，共 5 星',
  'BasedOnTotalReviews': '基于 {total} 条评论',
  'Write_a_review': '写评论',
  'reviewMostRecent': '最新评论',
  'good.shippingPeriod': '天内发货',
  'good.shoppingDateLabel': '发货时间',
  'emailError': '邮箱格式错误',
  'go_buy_goods': '继续购物',
  'Concactus': '联系',
  'showOrderSummary': '订单摘要',
  'emailNotNullError': '邮箱不能为空',
  'addressNote': '备注',
  'addressMessage': '请确保您的地址正确无误。结账后我们无法更改地址。',
  'orderCreateLoading': '订单创建中...',
  'emailNote': '联系',
  'emailMessage': '请确保您的邮箱地址正确无误。我们将向您发送订单确认邮件。',
  'payment_method': '支付方式',
  'payment_method_message': '所有交易都是安全和加密的。',
  'tap_cancel_order': '点击这里取消订单',
  'paymentMethodNotNull': '请选择支付方式',
  'Add_new_address': '添加新地址',
  'shippingInfoNotNull': '配送信息不完整',
  'BillingInfoNotNull': '账单信息不完整',
  'IdCardNotNull': '请填写实名信息',
  'uploadImageing': '上传中...',
  'UploadImage': '上传图片',
  'UploadVideo': '上传视频',
  'UploadError': '上传失败',
  'image': '图片',
  'video': '视频',
  'promo_code_type_1': '折扣劵',
  'promo_code_type_2': '代金券',
  'promo_code_type_3': '满送劵',
  'promo_code_type_4': '减运费劵',
  'reviewDetail': '评价详情',
  'save_review_success': '评价成功',
  'prompt_error': '提示错误',
  'ORDER_COMPLETED': '已完成',
  'crate_after_sales': '创建售后',
  'order_reivice_label': '订单收货',
  'order_reivice_btn': '确认收货',
  'order_reivice_message': '您确定已经收到货物了吗？',
  'order_reivice_success': '确认收货成功',
  'collpase_show': '查看更多',
  'collpase_hide': '收起',
  'wechatPayScannerCode': '请使用微信扫码支付',
  'thankyou_concat': '如有任何问题请与我们联系',
  'order_payment_list_null': '没有待支付的订单',
  'finished': '售后已完成',
  'processing': '售后处理中',
  'After_Sales_Unknown': '售后状态未知',
  'login.showPrice': '登录后查看价格'
};
